var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToeslagenLocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 148.21 134.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#New_Gradient_Swatch_copy_8-2);\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        mix-blend-mode: overlay;\n      }\n\n      .cls-4 {\n        opacity: .5;\n      }\n\n      .cls-5 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: url(#New_Gradient_Swatch_copy_8-3);\n      }\n\n      .cls-6 {\n        opacity: .75;\n      }\n\n      .cls-7 {\n        fill: none;\n      }\n\n      .cls-8 {\n        fill: #bcbcbc;\n      }\n\n      .cls-3 {\n        fill: url(#New_Gradient_Swatch_copy_8-4);\n      }\n\n      .cls-9 {\n        opacity: .25;\n      }\n\n      .cls-10 {\n        fill: url(#New_Gradient_Swatch_copy_8);\n        stroke: url(#linear-gradient);\n        stroke-miterlimit: 10;\n        stroke-width: 10px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8",
    "data-name": "New Gradient Swatch copy 8",
    x1: 5,
    y1: 67.18,
    x2: 143.21,
    y2: 67.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7b7b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 67.18,
    x2: 148.21,
    y2: 67.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-2",
    "data-name": "New Gradient Swatch copy 8",
    x1: 5,
    x2: 143.21,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-3",
    "data-name": "New Gradient Swatch copy 8",
    x1: 13.97,
    y1: 68.06,
    x2: 143.21,
    y2: 68.06,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-4",
    "data-name": "New Gradient Swatch copy 8",
    x1: 34.72,
    y1: 85.6,
    x2: 143.21,
    y2: 85.6,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m99.95,5h-51.69c-6.22,0-11.97,3.32-15.08,8.71L7.33,58.47c-3.11,5.39-3.11,12.03,0,17.42l25.85,44.77c3.11,5.39,8.86,8.71,15.08,8.71h51.69c6.22,0,11.97-3.32,15.08-8.71l25.85-44.77c3.11-5.39,3.11-12.03,0-17.42l-25.85-44.77c-3.11-5.39-8.86-8.71-15.08-8.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m99.95,129.37h-51.69c-5.31,0-10.29-2.42-13.54-6.49-.58-.69-1.09-1.43-1.54-2.22l-19.21-33.27-6.64-11.5c-3.11-5.38-3.11-12.02,0-17.41L33.18,13.71c3.11-5.39,8.86-8.71,15.08-8.71h51.69c2.68,0,5.28.62,7.61,1.76,3.08,1.49,5.7,3.89,7.47,6.95l16.24,28.13,9.61,16.64c3.11,5.39,3.11,12.03,0,17.41l-25.85,44.77c-3.11,5.39-8.86,8.71-15.08,8.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m140.88,75.89l-25.85,44.77c-3.11,5.39-8.86,8.71-15.08,8.71h-51.69c-5.31,0-10.29-2.42-13.54-6.49-.58-.69-1.09-1.43-1.54-2.22l-19.21-33.27C51.58,64.48,83.82,38.25,107.56,6.76c3.08,1.49,5.7,3.89,7.47,6.95l16.24,28.13,9.61,16.64c3.11,5.39,3.11,12.03,0,17.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m99.95,129.37h-51.69c-5.31,0-10.29-2.42-13.54-6.49,40.54-21.41,73.73-47.76,96.55-81.04l9.61,16.64c3.11,5.39,3.11,12.03,0,17.41l-25.85,44.77c-3.11,5.39-8.86,8.71-15.08,8.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m140.88,75.89l-25.85,44.77c-3.11,5.39-8.86,8.71-15.08,8.71h-51.69c-5.31,0-10.29-2.42-13.54-6.49-.58-.69-1.09-1.43-1.54-2.22l-19.21-33.27-6.64-11.5c-3.11-5.38-3.11-12.02,0-17.41L33.18,13.71c3.11-5.39,8.86-8.71,15.08-8.71h51.69c2.68,0,5.28.62,7.61,1.76,3.08,1.49,5.7,3.89,7.47,6.95l16.24,28.13,9.61,16.64c3.11,5.39,3.11,12.03,0,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m74.11,19.46c-13.74,0-24.88,11.14-24.88,24.88s11.14,24.88,24.88,24.88,24.88-11.14,24.88-24.88-11.14-24.88-24.88-24.88Zm1.97,20.37c1.2,0,2.12.83,2.12,2.03s-1.01,2.21-2.21,2.21h-10.69v.18c0,.37.09.65.09,1.01h10.69c1.2,0,2.21,1.01,2.21,2.21s-1.01,2.21-2.21,2.21h-9.12c1.75,2.77,4.89,4.52,8.29,4.52,3.23,0,5.07-1.2,7.29-3.41.46-.37,1.01-.65,1.57-.65.65,0,1.19.28,1.56.65.37.46.65,1.01.65,1.57s-.28,1.11-.65,1.57c-2.21,2.21-5.34,4.7-10.41,4.7-5.89,0-11.06-3.5-13.27-8.85h-2.12c-1.2,0-2.21-1.01-2.21-2.21s1.01-2.21,2.21-2.21h1.11v-1.2h-1.11c-1.2,0-2.21-1.01-2.21-2.21s1.01-2.21,2.21-2.21h1.84c2.03-5.72,7.38-9.68,13.55-9.68,5.07,0,8.21,2.49,10.41,4.7.46.46.65.92.65,1.57s-.18,1.2-.65,1.57c-.46.46-1.01.65-1.56.65-.65,0-1.2-.18-1.57-.65-2.12-2.21-3.97-3.41-7.29-3.41-3.69,0-7.09,2.12-8.75,5.35h9.58Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m32.92,100.55c-.69.79-.49,1.98.3,2.67l14.32,11.26c.79.69,1.98.49,2.67-.3l6.12-7.7-17.39-13.63-6.03,7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m109.97,75.86l-13.43,3.95v.99c-.3,3.75-3.06,6.91-6.72,7.61l-.89.1c-4.94.89-9.88,1.48-14.92,1.48l-4.05.1c-1.28,0-2.27-.99-2.27-2.27s.99-2.27,2.27-2.27l4.05-.1c4.74-.1,9.48-.59,14.13-1.48l.89-.2c1.68-.3,2.96-1.78,3.06-3.46.1-.99-.3-1.98-.99-2.77-.69-.79-1.58-1.19-2.67-1.28l-21.34-1.19c-2.37-.1-4.74.49-6.72,1.88l-18.18,12.74,18.18,14.32,17.98,2.07c3.16.4,6.32-.49,8.79-2.37l26.77-20.05c.99-.79,1.58-1.88,1.78-3.16.1-1.28-.3-2.47-1.09-3.36-1.19-1.28-2.96-1.78-4.64-1.28h0Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToeslagenLocked);
export default __webpack_public_path__ + "static/media/toeslagen_locked.1bc7f86fbf4fc398729a10bff0805005.svg";
export { ForwardRef as ReactComponent };